import React from 'react'

export function Sidebar() {
  return <div></div>
}
